<template>
    <div class="layout-footer">
      <span class="footer-text" style="margin-left: 5px">LZDS Online Enrollment System &copy; 2021</span>
    </div>     
</template>

<script>
export default {
    
}
</script>

<style scoped>
  .layout-footer {
    text-align: center;
    background-color: #00123a;
    color: white;
  }
</style>

